import { render, staticRenderFns } from "./CheckoutAddressSelector.vue?vue&type=template&id=404b8170"
import script from "./CheckoutAddressSelector.vue?vue&type=script&lang=js"
export * from "./CheckoutAddressSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports